import { queryServices } from '@wix/ambassador-bookings-services-v2-service/http';
export const queryServiceByFormId = async ({ httpClient, errorHandler, formId })=>{
    try {
        const response = await errorHandler.withErrorHandler(()=>httpClient.request(queryServices({
                query: {
                    filter: {
                        'form.id': {
                            $in: [
                                formId
                            ]
                        }
                    }
                }
            })), {
            errorCodesMap: {}
        });
        return response.data.services?.[0];
    } catch (e) {
        const resolvedError = errorHandler.getResolvedError(e);
        console.error(resolvedError);
        return undefined;
    }
};

//# sourceMappingURL=query-service-by-form-id.js.map